import { Injectable } from '@angular/core';
import { UsersService } from './users.service';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessRightsService {
  constructor(private usersService: UsersService) {}

  getNexusCentrexAccess(): Observable<'NoAccess' | 'ReadOnly' | 'FullAccess'> {
    return this.usersService.getSessionCurrentUser().pipe(
      map((user) => {
        const value =
          user?.properties?.find((p) => p.name?.trim() === 'NexusCentrex')
            ?.value || '';
        if (value.includes('2')) return 'FullAccess';
        if (value.includes('1')) return 'ReadOnly';
        return 'NoAccess';
      }),
    );
  }

  hasNexusCentrexFullAccess(): Observable<boolean> {
    return this.getNexusCentrexAccess().pipe(
      map((access) => access === 'FullAccess'),
    );
  }

  hasNexusCentrexReadOnly(): Observable<boolean> {
    return this.getNexusCentrexAccess().pipe(
      map((access) => access === 'ReadOnly'),
    );
  }
}
